import { render, staticRenderFns } from "./AStaffDetailInspection.vue?vue&type=template&id=ac891eb6&scoped=true"
import script from "./AStaffDetailInspection.vue?vue&type=script&lang=js"
export * from "./AStaffDetailInspection.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailInspection.vue?vue&type=style&index=0&id=ac891eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac891eb6",
  null
  
)

export default component.exports